export default function HomePage({ scrollToGenerate }) {

    return (
        <div className="bg-gradient-to-br from-pink-100 via-pink-50 to-white min-h-screen flex flex-col items-center justify-start py-10 px-4">
        <div className="max-w-4xl text-center">
            <h1 className="text-5xl font-extrabold text-pink-600 drop-shadow mb-4">
            Brat Font Generator ✨
            </h1>
            <p className="text-lg text-gray-700 mb-6">
            The <strong>#1 free brat generator</strong> for creating bold, sassy, and glamorous text! Perfect for celebrations, social media captions, birthdays, and viral moments. Our <strong>brat font generator</strong> transforms ordinary text into eye-catching designs with sparkles, unique fonts, and Y2K aesthetic—no watermarks, no fees!
            </p>

            <h2 className="text-5xl font-extrabold text-pink-600 drop-shadow mb-4">
            Sky Magic Fireworks ✨
            </h2>
            <p className="text-lg text-gray-700 mb-6">
            The <strong> brat font </strong> generates cool and amaizing animations and fireworks of your special day! You type your message and brat font generate foreworks and celebration gifs and animations. The sky magic fireworks are one of the key features of brat font, which covers your special day to celebrate more energetically with your loved ones.
            </p>

            <button
            onClick={scrollToGenerate}
            className="inline-block bg-white text-pink-600 hover:bg-gray-100 font-bold py-3 px-8 rounded-2xl shadow-lg transition duration-300 text-lg"
            >
            🎀 Generate Brat Text Now 🎀
            </button>

            {/* Featured Use Cases */}
            <div className="mt-12 bg-white p-6 rounded-2xl shadow-lg border border-pink-100">
            <h2 className="text-3xl font-bold text-pink-500 mb-6">What Can You Create?</h2>
            <div className="grid md:grid-cols-2 gap-6 text-left">
                <div className="bg-pink-50 p-4 rounded-xl">
                <h3 className="font-bold text-xl text-gray-800 mb-2">🎉 Celebrations</h3>
                <ul className="list-disc list-inside space-y-1 pl-4 text-gray-700">
                    <li>Sports team victories (e.g., "BARÇA CHAMPIONS! 💙❤️")</li>
                    <li>Graduation announcements with glitter effects</li>
                    <li>Festive holiday messages with custom fonts</li>
                </ul>
                </div>
                <div className="bg-pink-50 p-4 rounded-xl">
                <h3 className="font-bold text-xl text-gray-800 mb-2">💖 Social Media</h3>
                <ul className="list-disc list-inside space-y-1 pl-4 text-gray-700">
                    <li>Instagram captions that stand out</li>
                    <li>TikTok bio text with brat aesthetic</li>
                    <li>Twitter/X clapbacks in bold fonts</li>
                </ul>
                </div>
                <div className="bg-pink-50 p-4 rounded-xl">
                <h3 className="font-bold text-xl text-gray-800 mb-2">🎂 Personal Events</h3>
                <ul className="list-disc list-inside space-y-1 pl-4 text-gray-700">
                    <li>Birthday invitations with pink glitter text</li>
                    <li>Bachelorette party announcements</li>
                    <li>"It's a Girl/Boy" baby shower designs</li>
                </ul>
                </div>
                <div className="bg-pink-50 p-4 rounded-xl">
                <h3 className="font-bold text-xl text-gray-800 mb-2">💅 Personal Branding</h3>
                <ul className="list-disc list-inside space-y-1 pl-4 text-gray-700">
                    <li>Etsy shop banners with cute fonts</li>
                    <li>OnlyFans bio text generator</li>
                    <li>VSCO girl aesthetic profile text</li>
                </ul>
                </div>
            </div>
            </div>

            {/* Brat Font Explained */}
            <div className="mt-12 bg-white rounded-2xl shadow-md p-8 border border-pink-200">
            <h2 className="text-3xl font-bold text-pink-500 mb-4">What is Brat Font? 🦄</h2>
            <p className="text-gray-700 mb-4">
                <strong>Brat font</strong> is a viral typography style characterized by:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 pl-4">
                <li><strong>Bold, exaggerated lettering</strong> with playful curves</li>
                <li><strong>Sparkle effects ✨</strong> and glitter accents</li>
                <li><strong>Pastel pink/glam color schemes</strong></li>
                <li><strong>Y2K and barbiecore aesthetic</strong> influences</li>
                <li><strong>Sassy, unapologetic tone</strong> in text styling</li>
            </ul>
            <p className="text-gray-700">
                Popularized by Gen Z on TikTok and Instagram, our <strong>free brat generator</strong> makes this aesthetic accessible to everyone—no design skills needed!
            </p>
            </div>

            {/* How It Works */}
            <div className="mt-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">How Our Brat Generator Works</h2>
            <div className="grid md:grid-cols-3 gap-6 text-center">
                <div className="bg-white p-4 rounded-xl shadow-sm border border-pink-100">
                <div className="text-pink-500 text-3xl mb-2">1</div>
                <h3 className="font-bold text-lg mb-2">Enter Your Text</h3>
                <p className="text-gray-600">Type any message (names, phrases, etc.)</p>
                </div>
                <div className="bg-white p-4 rounded-xl shadow-sm border border-pink-100">
                <div className="text-pink-500 text-3xl mb-2">2</div>
                <h3 className="font-bold text-lg mb-2">Customize Style</h3>
                <p className="text-gray-600">Choose fonts, colors, sparkles, backgrounds</p>
                </div>
                <div className="bg-white p-4 rounded-xl shadow-sm border border-pink-100">
                <div className="text-pink-500 text-3xl mb-2">3</div>
                <h3 className="font-bold text-lg mb-2">Download & Share</h3>
                <p className="text-gray-600">Get your brat text as PNG or copy instantly</p>
                </div>
            </div>
            </div>

            {/* Testimonials */}
            <div className="mt-12 bg-pink-50 rounded-2xl p-8 border border-pink-200">
            <h2 className="text-2xl font-bold text-pink-600 mb-6">What Users Say About Our Brat Font Generator</h2>
            <div className="grid gap-6 md:grid-cols-2">
                <div className="bg-white p-4 rounded-lg shadow">
                <p className="italic mb-2">"This free brat generator saved my Instagram game! My captions get 3x more likes now."</p>
                <p className="font-semibold text-pink-600">- @TikTokGlamGirl</p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow">
                <p className="italic mb-2">"Used it for my sister's bachelorette invites - everyone thought I paid a designer!"</p>
                <p className="font-semibold text-pink-600">- Sarah M.</p>
                </div>
            </div>
            </div>

            {/* FAQ */}
            <div className="mt-12 text-left">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Frequently Asked Questions</h2>
            <div className="space-y-4">
                <div className="border-b border-pink-100 pb-4">
                <h3 className="font-bold text-lg text-pink-600">Is this brat generator really free?</h3>
                <p className="text-gray-700 mt-1">Yes! Our brat font generator is 100% free with no hidden costs—no watermarks, no premium paywall.</p>
                </div>
                <div className="border-b border-pink-100 pb-4">
                <h3 className="font-bold text-lg text-pink-600">What's the difference between brat font and other fancy text?</h3>
                <p className="text-gray-700 mt-1">Brat font specifically captures the Y2K, VSCO girl, and barbiecore aesthetic with bolder styling and sparkle elements compared to standard fancy text generators.</p>
                </div>
                <div className="border-b border-pink-100 pb-4">
                <h3 className="font-bold text-lg text-pink-600">Can I use brat fonts for commercial purposes?</h3>
                <p className="text-gray-700 mt-1">Absolutely! All generated content is royalty-free for personal and commercial use.</p>
                </div>
            </div>
            </div>

            {/* Final CTA */}
            <div className="mt-12 bg-gradient-to-r from-pink-500 to-pink-600 text-white p-8 rounded-2xl shadow-xl">
            <h2 className="text-3xl font-bold mb-4">Ready to Bratify Your Text?</h2>
            <p className="text-xl mb-6">Join thousands creating viral-worthy content in seconds!</p>
            <button
            onClick={scrollToGenerate}
            className="inline-block bg-white text-pink-600 hover:bg-gray-100 font-bold py-3 px-8 rounded-2xl shadow-lg transition duration-300 text-lg"
            >
            🎀 Generate Brat Text Now 🎀
            </button>
            </div>

            {/* SEO Footer */}
            <div className="mt-12 text-sm text-gray-500 text-center">
            <p>Keywords: brat generator, brat generator free, free brat generator, brat font, brat font generator, what is brat, what is brat font, glitter text generator, sassy text generator, Y2K text generator, barbiecore font, VSCO girl text, TikTok font generator, Instagram caption generator, fancy text generator, pink glitter font, unicode text generator</p>
            <p className="mt-4">Popular Searches: how to make brat text, free aesthetic font generator, brat style captions, generate bratty text online, cute font maker for social media</p>
            </div>
        </div>
        </div>
    );
}